(function() {
  'use strict';

  function ReportViewEventsController($scope, Utils, ReportWrapperService) {
    var ctrl = this;

    Utils.setPageTitle('Report viewer');

    ctrl.loading = true;
    function loadEvents() {
      if (ctrl.list === undefined) {
        ctrl.list = ReportWrapperService.reportViewer.list;
      }
    }

    ctrl.$onChanges = function() {
      // This is for the case when it's done faster then this controller is loaded
      if (
        ReportWrapperService.reportViewer.list
        && ReportWrapperService.reportViewer.list.initialized
      ) {
        loadEvents();
      }

      $scope.$on('reportsviewer.listUpdated', function() {
        loadEvents();
      });

      ctrl.report = {};
    };
  }

  ReportViewEventsController.$inject = ['$scope', 'UtilsService', 'ReportWrapperService'];

  angular.module('component.reports')
    .component('reportViewEvents', {
      controller: ReportViewEventsController,
      controllerAs: 'reportViewEventsCtrl',
      templateUrl: 'app/components/reports/view.html',
      bindings: {
        showActionButtons: '<'
      }
    });
})();
